import { useRef } from 'react';
import { useInView } from '../../hooks/useInView';

const stats = [
  {
    icon: 'ri-star-fill',
    value: '5.0',
    unit: '★★★★★',
    label: 'Average Client Rating',
    sub: 'Consistent 5-star experiences',
  },
  {
    icon: 'ri-user-heart-line',
    value: '500+',
    unit: '',
    label: 'Sessions Completed',
    sub: 'Across Yardley & Bucks County, PA',
  },
  {
    icon: 'ri-heart-pulse-line',
    value: '4+',
    unit: 'Modalities',
    label: 'Integrated Per Session',
    sub: 'Holistic, personalized approach',
  },
  {
    icon: 'ri-shield-check-line',
    value: '100%',
    unit: '',
    label: 'Root-Cause Focused',
    sub: 'No symptom masking, ever',
  },
];

export default function TrustBar() {
  const { ref, inView } = useInView();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="bg-[#0a0a0a] border-t border-b border-[#d4af37]/8 py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <p
          className="text-center text-[#5a5a5a] text-[10px] uppercase tracking-[0.3em] mb-12"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Trusted by clients seeking deeper healing and lasting transformation
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#1a1a1a]">
          {stats.map((item, idx) => (
            <div
              key={idx}
              className={`bg-[#0a0a0a] flex flex-col items-center text-center px-8 py-10 transition-all duration-700 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="w-11 h-11 flex items-center justify-center mb-5 rounded-full bg-[#d4af37]/8">
                <i className={`${item.icon} text-[#d4af37] text-xl`} />
              </div>
              <div className="flex items-baseline gap-1 mb-1">
                <span
                  className="text-white text-3xl font-light"
                  style={{ fontFamily: 'Cormorant Garamond, serif' }}
                >
                  {item.value}
                </span>
                {item.unit && (
                  <span className="text-[#d4af37] text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {item.unit}
                  </span>
                )}
              </div>
              <p className="text-white text-xs font-medium uppercase tracking-[0.1em] mb-1" style={{ fontFamily: 'Inter, sans-serif' }}>
                {item.label}
              </p>
              <p className="text-[#4a4a4a] text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
                {item.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
